import React from 'react';
import { hydrate } from 'react-dom';
import HeaderScaffold from '../app/scaffold/Header';

const getInitialData = async url => {
  try {
    const response = await fetch(url, {
      headers: { 'Cache-Control': 'no-cache' },
    });
    const jsonData = await response.json();
    return jsonData;
  } catch (err) {
    console.error(`Header: error fetching initial data err: ${err}`);
    return {};
  }
};

const loadInitialState = async () => {
  try {
    const initialState = await getInitialData(`/header/api/state`);
    const headerAppEl = document.getElementById('root');

    if (headerAppEl) {
      hydrate(<HeaderScaffold initialState={initialState} />, headerAppEl);
      // eslint-disable-next-line no-underscore-dangle
      window.__PRELOADED_STATE__ = initialState;
    }
  } catch (err) {
    console.error(`Error hydrating application ${err}`);
  }
};

document.addEventListener('DOMContentLoaded', loadInitialState);
